import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button, Chip
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { extractTitleFromUrl } from '../../common/layer/util';


const LayersFromCatalog = ({ 
  catalog, loadLayerAndDispatch, 
  map, layers, dispatch, handleCloseDialog, 
  setCatalogs, activeCatalog, setActiveCatalog}) => {


  const zoomTo = layers.length ===0 ? true : false;
  
  const handleRemoveCatalog = () => {
    setCatalogs(currentCatalogs => currentCatalogs.filter(c => c.id !== catalog.id));
    layers.forEach(layer => {
      if (layer.catalogId === catalog.id) {
        deleteLayer(layer);
      }
    });
  };

  const handleDeleteLayers = () => {
    layers.forEach(layer => {
      if (layer.catalogId === catalog.id) {
        deleteLayer(layer);
      }
    });
  };

  const deleteLayer = (layer) => {
    map.current.removeLayer(layer.id);
    map.current.removeSource(layer.sourceId);
    dispatch({ type: 'DELETE_LAYER', payload: layer.id});
  };

  return (
  <div className="layerFromCatalog">
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h5> Layers from <Chip label={catalog?.id}/> </h5>
        <div className="catalogHeader" >
          <IconButton aria-label="remove" color="secondary" onClick={handleRemoveCatalog}>
            Remove Catalog<CloseIcon />
          </IconButton>
          <IconButton aria-label="delete" color="secondary" onClick={handleDeleteLayers}>
            Delete All Layers <DeleteIcon />
          </IconButton>
        </div>
      </div>
    <Accordion key='hexagonAccordion' className="assetAccordion">
      <AccordionSummary className="assetAccordionSummary" expandIcon={<ExpandMoreIcon />}>
        Factor - hexagon
      </AccordionSummary>
      <AccordionDetails className="accordion-details">

        {Array.isArray(catalog?.assets?.factor?.hexagon) && 
          catalog.assets.factor.hexagon.map((assetUrl, index) => ( 
          <div key={`hexa-${index}`} className="assetItem"> 
            <Button
              variant="outlined" size="small" color="success"
              onClick={() => {
                loadLayerAndDispatch(
                  map.current, assetUrl, 'HEXAGON', dispatch, zoomTo, catalog.id 
                );
                handleCloseDialog();
              }}
            >add</Button>
            <span>{extractTitleFromUrl(assetUrl, false)}</span>
          </div>
        ))}
      </AccordionDetails>
    </Accordion>
    <Accordion key='ficture' className="assetAccordion">
      <AccordionSummary className="assetAccordionSummary" expandIcon={<ExpandMoreIcon />}>
        Factor - Ficture
      </AccordionSummary>
      <AccordionDetails className="accordion-details">
        {Array.isArray(catalog?.assets?.factor?.pixel) && 
          catalog.assets.factor.pixel.map((assetUrl, index) => (
          <div key={`fic-${index}`} className="assetItem"> 
            <Button
              variant="outlined" size="small" color="success"
              onClick={() => {
                loadLayerAndDispatch(
                  map.current, assetUrl, 'FICTURE', dispatch, zoomTo, catalog.id
                );
                handleCloseDialog();
              }}
            >add</Button>
            <span>{extractTitleFromUrl(assetUrl, false)}</span>
          </div>
        ))}
      </AccordionDetails>
    </Accordion>
    <Accordion key='basemap' className="assetAccordion">
      <AccordionSummary className="assetAccordionSummary" expandIcon={<ExpandMoreIcon />}>
        Histology/Background 
      </AccordionSummary>
      <AccordionDetails className="accordion-details">
        {Array.isArray(catalog?.assets?.basemap) && 
          catalog.assets.basemap.map((assetUrl, index) => (
          <div key={`bg-${index}`} className="assetItem">
              <Button
                variant="outlined" size="small" color="success"
                onClick={() => {
                  loadLayerAndDispatch(
                    map.current, assetUrl, 'BACKGROUND', dispatch, zoomTo, catalog.id 
                  );
                  handleCloseDialog();
                }}
              >add</Button>
              <span>{extractTitleFromUrl(assetUrl, false)}</span>
            </div>
          ))}
      </AccordionDetails>
    </Accordion>

  </div>
  );
}

export default LayersFromCatalog;
